import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import productEnquiryService from "./productEnquiryService";

export const getProductEnquiries = createAsyncThunk(
  "product-enquiry/all",
  async (thunkAPI) => {
    try {
      return await productEnquiryService.getProductEnquiries();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteAProductEnquiry = createAsyncThunk(
  "product-enquiry/delete",
  async (id, thunkAPI) => {
    try {
      return await productEnquiryService.deleteProductEnquiry(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getAProductEnquiry = createAsyncThunk(
  "product-enquiry/get",
  async (id, thunkAPI) => {
    try {
      return await productEnquiryService.getProductEnquiry(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const updateAProductEnquiry = createAsyncThunk(
  "product-enquiry/edit",
  async (enquiry, thunkAPI) => {
    try {
      return await productEnquiryService.updateProductEnquiry(enquiry);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const resetState = createAction("Reset_product_enquiry_all");

const initialState = {
  productEnquiries: [],
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};

export const productEnquirySlice = createSlice({
  name: "productEnquiries",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getProductEnquiries.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getProductEnquiries.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.productEnquiries = action.payload.result;
      })
      .addCase(getProductEnquiries.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(deleteAProductEnquiry.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteAProductEnquiry.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.deletedProductEnquiry = action.payload;
      })
      .addCase(deleteAProductEnquiry.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(getAProductEnquiry.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAProductEnquiry.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.enquiryName = action.payload.name;
        state.enquiryMobile = action.payload.mobile;
        state.enquiryEmail = action.payload.email;
        state.enquiryProductName = action.payload.product_name;
        state.enquiryDesignCode = action.payload.design_code;
        state.enquiryImg = action.payload.img;
        state.enquiryUrl = action.payload.url;
        state.enquiryStatus = action.payload.status;
      })
      .addCase(getAProductEnquiry.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(updateAProductEnquiry.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateAProductEnquiry.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.updatedProductEnquiry = action.payload.result;
      })
      .addCase(updateAProductEnquiry.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(resetState, () => initialState);
  },
});

export default productEnquirySlice.reducer;
